import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import React from 'react';
import { LinkIconButton } from './LinkIconButton';

export const BackIconButton: React.FC<React.ComponentProps<typeof LinkIconButton>> = props => {
  return (
    <LinkIconButton {...props}>
      <ArrowBackIcon />
    </LinkIconButton>
  );
};
